import React, { useState, useContext } from 'react';
import { Modal } from '@mui/material';
import UploadFile from './Modal';
import DocumentRow from './DocumentRow';
import DeleteCommonModal from '../Modals/DeleteModal';
import CasesAPI from 'api/CasesAPI';
import { useSnackbar } from 'notistack';
import { GlobalContext } from 'providers/GlobalProvider';

interface ILibTableProps {
  tableName: string;
  cur_case: any;
  trigger: boolean;
  setTrigger: any;
}

const DocumentsTable: React.FC<ILibTableProps> = (props: ILibTableProps) => {
  const { tableName, cur_case, trigger, setTrigger } = props;

  const { enqueueSnackbar } = useSnackbar();
  const { cur_user } = useContext(GlobalContext);

  const [isModalOpen, setModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteDoc, setDeleteDoc] = useState<any>({});

  const itemsPerPage = 5;
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate the total number of pages
  const totalPages = Math.max(
    1,
    Math.ceil(cur_case.data.documents.length / itemsPerPage),
  );

  // Calculate the current items to display based on the page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = cur_case.data.documents.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );

  // Function to handle page change
  const handleNextPage = () => {
    setCurrentPage((prevPage) =>
      Math.min(
        prevPage + 1,
        Math.ceil(cur_case.data.documents.length / itemsPerPage),
      ),
    );
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const deleteDocFromCase = async () => {
    const updatedDocs = cur_case.data.documents.filter((doc: any) => {
      return doc.uploadedFile.name !== deleteDoc.uploadedFile.name;
    });
    const actObj: any = {
      user: {
        kc_id: cur_user.basics?.id,
        email: cur_user.basics?.email,
        firstName: cur_user.basics?.firstName,
        lastName: cur_user.basics?.lastName,
      },
      action: `removed the document ${deleteDoc?.uploadedFile.name}`,
      timeStamp: Date.now(),
    };

    const res = await CasesAPI.updateCase({
      _id: cur_case.data._id,
      documents: updatedDocs,
      activity: [...cur_case.data.activity, actObj],
    });
    if (res?.success) {
      enqueueSnackbar('File removed!', { variant: 'success' });
      setDeleteDoc({});
      setIsDeleteModalOpen(false);
      setTrigger(!trigger);
    }
  };

  return (
    <>
      <div className='audit-doc-frame'>
        <div className='audit-doc-table'>
          <div className='audit-doc-table-head'>
            <div>
              <div className='audit-doc-table-head-text'>
                <div className='audit-doc-table-head-text-frame'>
                  <div>
                    <div className='audit-doc-table-head-text-frame-left'>
                      {tableName}
                    </div>

                    <div
                      className='audit-doc-table-head-text-frame-upload'
                      onClick={() => setModalOpen(true)}
                    >
                      + Upload
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='audit-doc-tabe-col'>
            <div className='audit-doc-tabe-col-left-cell'>
              <div style={{ display: 'flex', gap: '4px' }}>
                <div className='audit-doc-tabe-col-left-cell-text'>
                  File Name
                </div>
              </div>
            </div>
            <div className='audit-doc-tabe-col-right-cell'>
              <div>
                <div className='audit-doc-tabe-col-left-cell-text'>
                  Date Uploaded
                </div>
              </div>
            </div>
            <div className='audit-doc-tabe-col-right-cell'>
              <div>
                <div className='audit-doc-tabe-col-left-cell-text'>Status</div>
              </div>
            </div>
            <div className='audit-doc-tabe-col-empty-cell'></div>
          </div>
          {currentItems.map((item: any, index: number) => (
            <React.Fragment key={index}>
              <DocumentRow
                item={item}
                setDeleteDoc={setDeleteDoc}
                setIsDeleteModalOpen={setIsDeleteModalOpen}
              />
              {index < 5 && (
                <div className='activity-cont-frame-left-table-feed-row-cont-divider'></div>
              )}
            </React.Fragment>
          ))}
          <div className='activity-cont-frame-pagination'>
            <div className='activity-cont-frame-pagination-text'>
              Page {currentPage} of {totalPages}
            </div>
            <div className='activity-cont-frame-pagination-action'>
              <div
                className='activity-cont-frame-pagination-action-prev'
                onClick={handlePrevPage}
              >
                <div className='activity-cont-frame-pagination-action-text'>
                  Previous
                </div>
              </div>
              <div
                className='activity-cont-frame-pagination-action-prev'
                onClick={handleNextPage}
              >
                <div className='activity-cont-frame-pagination-action-text'>
                  Next
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal open={isModalOpen} backdrop='static' keyboard={false}>
        <UploadFile cur_case={cur_case} setUploadMode={setModalOpen} />
      </Modal>
      <Modal
        open={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
      >
        <DeleteCommonModal
          handleClose={() => setIsDeleteModalOpen(false)}
          title={'Delete document?'}
          paragraph={'This action cannot be undone.'}
          handleDelete={deleteDocFromCase}
        />
      </Modal>
    </>
  );
};

export default DocumentsTable;
